import styled from "styled-components";
export const PaginationItemContainer = styled.div `
  font-size: ${({ theme }) => theme.fontTokens.font12[0]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.black};
  background: ${({ active, theme }) => active ? `rgb(${theme.colors.transparentBlack}, 0.2)` : "none"};
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border: 1px solid rgb(${({ theme }) => theme.colors.transparentBlack}, 0);
  outline: none;
  height: 2.5rem;
  width: ${({ isIcon }) => (isIcon ? "1rem" : "2.5rem")};

  @media ${({ theme }) => theme.device.touch} {
    height: 2.75rem;
    width: ${({ isIcon }) => (isIcon ? "1rem" : "2.75rem")};
    min-width: ${({ isIcon }) => (isIcon ? "1rem" : "2.75rem")};
    min-height: 2.75rem;
  }

  div:first-child {
    display: none;
  }

  @media (hover: hover) {
    :hover {
      div:first-child {
        display: flex;
      }
      div:last-child {
        display: none;
      }
      ${({ theme, active }) => active
    ? ""
    : `background: rgb(${theme.colors.transparentBlack}, 0.08);`}
      cursor: pointer;
    }
  }

  :focus {
    ${({ focused }) => focused
    ? `
    div:first-child {
      display: flex;
    }
    div:last-child {
      display: none;
    }
    `
    : ""}
    ${({ theme, focused }) => focused ? `outline: 1px solid  ${theme.colors.primaryLight};` : ""}
    ${({ theme, focused }) => focused ? `border: 1px solid  ${theme.colors.primaryLight};` : ""}
  }

  :active {
    ${({ theme }) => theme.global.disableTapHighlight}

    background: ${({ theme, active }) => (active ? "" : theme.colors.grey15)};
    color: ${({ theme, active }) => (active ? "" : theme.colors.white)};
  }

  :disabled {
    color: rgb(${({ theme }) => theme.colors.transparentBlack}, 0.26);
  }
`;
export const StyledIconsContainer = styled.div `
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  span {
    & svg {
      width: 1rem;
      height: 1rem;
    }
  }

  :active {
    ${({ theme }) => theme.global.disableTapHighlight}

    span svg {
      fill: ${({ theme }) => theme.colors.white};
    }
  }
`;
